import { Flex } from '@wegroup/design-system';
import React from 'react';

interface Props {
  onClick?: () => void;
}

const QuestionViewHeaderButton: React.FC<React.PropsWithChildren<Props>> = ({
  onClick,
  children,
  ...rest
}) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      bg="primary.100"
      borderRadius="full"
      h="4.4rem"
      padding="1"
      onClick={onClick}
      _active={{
        bg: 'primary.200',
      }}
      transition="0.1s"
      {...rest}
    >
      {children}
    </Flex>
  );
};

export default QuestionViewHeaderButton;
